import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import { getEmailStatus } from "Services/AdminServices/OnBoardingService";
import { submitOnboardingData } from "Services/AdminServices/OnBoardingService";
import { JobApplicationStatusEnum } from "Constants/Enums/JobApplicantStatusEnum";

function useOnboardingProcess() {
  const params = useParams();

  const { param1 } = useParams(); // extract only empId
  const jobApplicantIdNum = Number(param1);
  const jobApplicantId = jobApplicantIdNum;
  const navigate = useNavigate();
  const location = useLocation();
  const employeeEmail = location.state?.employeeEmail;

  const [formData, setFormData] = useState({
    jobApplicantId: jobApplicantIdNum,
    welcomeEmail: "",
    mentorAssignment: "",
    recurringOneOnOneMeetings: "",
    firstDayMeetings: "",
    welcomeMeeting: "",
    welcomeLunch: "",
    businessIntroduction: "",
    officeTour: "",
    regularCheckIns: "",
    shadowingOpportunities: "",
    adHocSupport: "",
    benefitsEnrollment: "",
    emergencyContactInfo: "",
    employeeHandbook: "Employee handbook featuring all company policies.",
    directDepositInfo: "Direct deposit and payroll information.",
    employmentEligibilityForm: "1-9 form (employment eligibility verification).",
    ndaOrNonCompete:
      "Non-disclosure agreement, non-compete, or confidentiality agreement (if applicable).",
    stateTaxWithholdingForm: "",
    federalTaxWithholdingForm:
      "W-4 form (employee`s withholding certificate for federal taxes) or W-9 for contractors.",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const fetchEmailStatus = async () => {
      try {
        const data = await getEmailStatus(jobApplicantId);
        setIsSubmitted(
          data.status === JobApplicationStatusEnum.OnboardingDone ||
            data.status === JobApplicationStatusEnum.Hired
        );
      } catch (error) {
        message.error("Failed to fetch email status");
      }
    };

    fetchEmailStatus();
  }, [employeeEmail]);

  const handleSubmit = async () => {
    try {
      const payload = {
        jobApplicantId: jobApplicantId, // ensure int
        welcomeEmail: formData.welcomeEmail || "pending",
        mentorAssignment: formData.mentorAssignment || "pending",
        recurringOneOnOneMeetings: formData.recurringOneOnOneMeetings || "pending",
        firstDayMeetings: formData.firstDayMeetings || "pending",
        welcomeMeeting: formData.welcomeMeeting || "pending",
        welcomeLunch: formData.welcomeLunch || "pending",
        businessIntroduction: formData.businessIntroduction || "pending",
        officeTour: formData.officeTour || "pending",
        regularCheckIns: formData.regularCheckIns || "pending",
        shadowingOpportunities: formData.shadowingOpportunities || "pending", //  fixed key
        adHocSupport: formData.adHocSupport || "pending",
        benefitsEnrollment: formData.benefitsEnrollment || "pending",
        emergencyContactInfo: formData.emergencyContactInfo || "pending",
        employeeHandbook: formData.employeeHandbook || "pending",
        directDepositInfo: formData.directDepositInfo || "pending",
        employmentEligibilityForm: formData.employmentEligibilityForm || "pending",
        ndaOrNonCompete: formData.ndaOrNonCompete || "pending",
        stateTaxWithholdingForm: formData.stateTaxWithholdingForm || "pending",
        federalTaxWithholdingForm: formData.federalTaxWithholdingForm || "pending",
      };

      const response = await submitOnboardingData(payload);

      message.success("Onboarding data added successfully");
      localStorage.setItem(`onboarding_${jobApplicantId}`, "submitted");
      setIsSubmitted(true);
      navigate(`/humanResource/${jobApplicantId}`);
    } catch (error) {
      message.error("Failed to add onboarding data, please try again");
    }
  };

  const handleNavigation = () => {
    navigate(`/humanResource/${jobApplicantId}`);
  };

  return {
    formData,
    setFormData,
    handleSubmit,
    isSubmitted,
    handleNavigation,
  };
}

export default useOnboardingProcess;
